import {
    Box,
    Flex,
    Heading,
    Image,
    Link as LinkStyle,
    Text,
    useToast
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { LanguagePicker } from "../../components/LanguagePicker";
import {
    IRequestPasswordResetValues,
    RequestPasswordResetForm
} from "../../forms";
import {
    IResetPasswordValues,
    ResetPasswordForm
} from "../../forms/ResetPassword";
import {
    useRequestPasswordResetMutation,
    useResetPasswordMutation
} from "../../graphql";
import AuthPage from "../../layouts/Authentication";

const ResetPasswordPage: React.FC = ({ children }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const toast = useToast();
    const [requestSent, setRequestSent] = useState(false);
    const [email, setEmail] = useState("");

    const [requestPasswordReset] = useRequestPasswordResetMutation();
    const [resetPassword] = useResetPasswordMutation();

    const handleRequestPasswordReset = async (
        data: IRequestPasswordResetValues
    ) => {
        await requestPasswordReset({
            variables: {
                email: data.email
            }
        });

        toast({
            title: "Sukses",
            description: "Kodi i verifikimit u dërgua në emailin tuaj.",
            status: "success"
        });

        setRequestSent(true);
    };

    const handleResetPassword = async (data: IResetPasswordValues) => {
        await resetPassword({
            variables: {
                email: email,
                password: data.password,
                verificationCode: data.verificationCode
            }
        });

        toast({
            title: "Sukses",
            description:
        "Fjalëkalimi u rivendos me sukses. Përdoreni për tu identifikuar përsëri.",
            status: "success"
        });

        history.push("/login");
    };

    return (
        <AuthPage>
            <Flex width="full" align="center" justifyContent="center" marginTop={ 20 }>
                <Box
                    p={ 5 }
                    background="white"
                    borderWidth={ 1 }
                    borderRadius={ 8 }
                    boxShadow="lg"
                    w={ [300, 300, 400, 420, 430] }
                >
                    <Box textAlign="center">
                        <Image src="/logo-white.png" />

                        <Heading>{ t("login.resetPassword") }</Heading>
                        <Text>
                            { t("login.haveAccount") }{ " " }
                            <LinkStyle>
                                <Link to="/login">{ t("login.login") }</Link>
                            </LinkStyle>
                        </Text>
                    </Box>

                    { !requestSent ? (
                        <RequestPasswordResetForm
                            onSubmit={ (data) => {
                                handleRequestPasswordReset(data);
                                setEmail(data.email);
                            } }
                        />
                    ) : (
                        <ResetPasswordForm onSubmit={ (data) => handleResetPassword(data) } />
                    ) }

                    <Box my={ 4 } textAlign="left"></Box>
                    <LanguagePicker />
                </Box>
            </Flex>
        </AuthPage>
    );
};

export default ResetPasswordPage;
